import React, { useEffect } from 'react';
import { IoClose } from 'react-icons/io5';
import styles from './Modal.module.css';

const Modal = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.wrapper} onClick={e => e.stopPropagation()}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h3 className={styles.title}>{title}</h3>
            <button 
              className={styles.closeButton}
              onClick={onClose}
              aria-label="Kapat"
            >
              <IoClose size={24} />
            </button>
          </div>
          <div className={styles.body}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal; 